export default __webpack_public_path__ + "static/media/lora-v15-latin-700.f6736f37.woff";